function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  fill: "#17a7ec"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "settings",
  transform: "translate(5 5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M6.326,13.5a1.244,1.244,0,0,1-1.243-1.243v-.286a5.465,5.465,0,0,1-.846-.352l-.2.2a1.243,1.243,0,0,1-1.758,0l-.6-.6a1.244,1.244,0,0,1,0-1.759l.2-.2a5.465,5.465,0,0,1-.352-.846H1.243A1.244,1.244,0,0,1,0,7.174V6.326A1.244,1.244,0,0,1,1.243,5.083h.286a5.465,5.465,0,0,1,.352-.846l-.2-.2a1.243,1.243,0,0,1,0-1.758l.6-.6a1.243,1.243,0,0,1,1.758,0l.2.2a5.465,5.465,0,0,1,.846-.352V1.243A1.244,1.244,0,0,1,6.326,0h.848A1.244,1.244,0,0,1,8.417,1.243v.286a5.465,5.465,0,0,1,.846.352l.2-.2a1.243,1.243,0,0,1,1.758,0l.6.6a1.244,1.244,0,0,1,0,1.759l-.2.2a5.465,5.465,0,0,1,.352.846h.286A1.244,1.244,0,0,1,13.5,6.326v.848a1.244,1.244,0,0,1-1.243,1.243h-.286a5.465,5.465,0,0,1-.352.846l.2.2a1.243,1.243,0,0,1,0,1.758l-.6.6a1.243,1.243,0,0,1-1.758,0l-.2-.2a5.465,5.465,0,0,1-.846.352v.286A1.244,1.244,0,0,1,7.174,13.5Z",
  transform: "translate(0 0)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M0,2.938A2.937,2.937,0,1,1,2.938,5.874,2.941,2.941,0,0,1,0,2.938Z",
  transform: "translate(3.813 3.813)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.4
}));

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.8a4f0122.svg";
export { ForwardRef as ReactComponent };